import { Editor, Transforms } from 'slate';
import { isTag } from './navigation';

/**
 * Remove a tag and properly handle continuation chain
 * If tag is in middle of chain, reconnects the chain
 */
export const removeTag = (editor: Editor, tagId: string): void => {
  const entry = Array.from(
    Editor.nodes(editor, {
      at: [],
      match: (n) => isTag(n) && n.tagId === tagId,
    })
  )[0];

  if (!entry) return;

  const [node, path] = entry;

  Editor.withoutNormalizing(editor, () => {
    // Find predecessor and successor in chain
    const predecessor = Array.from(
      Editor.nodes(editor, {
        at: [],
        match: (n) => isTag(n) && n.continuedAt === tagId,
      })
    )[0];

    const successorId = (node as any).continuedAt;

    // If this tag is in the middle of a chain, reconnect
    if (predecessor && successorId) {
      Transforms.setNodes(editor, { continuedAt: successorId } as any, { at: predecessor[1] });
    } else if (predecessor) {
      // This was the end of a chain, remove continuedAt from predecessor
      Transforms.setNodes(editor, { continuedAt: undefined } as any, { at: predecessor[1] });
    }

    // Unwrap the tag node (removes the tag but keeps the text)
    Transforms.unwrapNodes(editor, { at: path });
  });
};
